module.exports = __webpack_public_path__ + "img/2sigin_logo.5f819d8f.png";